<template>
  <UIModal v-model="isOpen" @closed="emit('closed')">
    <template #header>
      <div class="tw:flex tw:flex-col tw:items-center tw:gap-3 tw:text-white">
        <h2 class="tw:font-bold tw:text-3xl">{{ $t('halloweenModalLoginRequiredTitle') }}</h2>
        <p class="tw:font-medium tw:text-xl">{{ $t('halloweenModalLoginRequiredSubtitle') }}</p>
      </div>
    </template>
    <div
      class="tw:flex tw:justify-center tw:items-center tw:bg-[url(img/halloween/login/login_background.png)] tw:bg-cover tw:bg-center tw:py-14 tw:border tw:border-blue-8 tw:lg:min-w-4xl tw:min-h-[400px]"
    >
      <!-- <img src="/img/halloween/login/pumpkin.png" /> -->
    </div>
    <template #footer>
      <div class="tw:flex tw:justify-center">
        <HalloweenGenericButton @click="handleAuth">{{
          $t('halloweenModalLoginRequiredButton')
        }}</HalloweenGenericButton>
      </div>
    </template>
  </UIModal>
</template>

<script setup lang="ts">
import { useWeb3Modal, useWeb3ModalAccount } from '@web3modal/ethers/vue';

const isOpen = defineModel<boolean>({ required: true });

const emit = defineEmits(['connected', 'closed']);

const { open: openWallet } = useWeb3Modal();
const { isConnected } = useWeb3ModalAccount();

const closeModal = () => {
  isOpen.value = false;
  emit('closed');
};

async function handleAuth() {
  try {
    if (isConnected.value) {
      closeModal();
      return;
    }
    await openWallet();
    useTrackEvent('login');
  } catch (error) {
    console.error('Error during opening wallet window:', error);
  } finally {
    closeModal();
  }
}

whenever(isConnected, () => {
  closeModal();
  emit('connected');
});
</script>
